import React, { useEffect, useState } from "react";
import { DocumentDownloadIcon } from "@heroicons/react/solid";
import ReactGA from "react-ga";
// import { Container } from '@/components/Container';
// import DoubleHeading from "../products/double-heading";

// const samples = [
//   {
//     id: "52",
//     title: "GS PAPER 1 - Volume 1",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Art and Culture",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134642/1.-G.S.-Paper-%E2%80%93-1-Volume-%E2%80%93-1-06-04-Art-_-Culture-BOOK-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "344",
//     title: "GS PAPER 1 - Volume 2",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Ancient and Medieval History of India",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134644/2.-G.S.-Paper-%E2%80%93-1-Volume-%E2%80%93-2-06-04-Ancient-and-Medieval-History-of-India-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "345",
//     title: "GS PAPER 1 - Volume 3",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Modern Indian History",
//     label: "NULL",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134647/3.-G.S.-Paper-%E2%80%93-1-Volume-%E2%80%93-3-06-04-Morden-Indian-History-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "346",
//     title: "GS PAPER 1 - Volume 4",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "World History and World Geography(Mapping)",
//     label: "NULL",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134649/4.-G.S.-Paper-%E2%80%93-1-Volume-%E2%80%93-4-06-04-World-History-and-World-Geography-Mapping-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "347",
//     title: "GS PAPER 1 - Volume 5",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Geography of World",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134652/5.-G.S.-Paper-%E2%80%93-1-Volume-%E2%80%93-5-06-04-Geography-of-World-BOOK-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "348",
//     title: "GS PAPER 1 - Volume 6",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Indian Geography",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134654/6.-G.S.-Paper-%E2%80%93-1-Volume-%E2%80%93-6-06-04-Indian-Geography-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "349",
//     title: "GS PAPER 2 - Volume 1",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Polity and Constitution",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134656/7.-G.S.-Paper-%E2%80%93-2-Volume-%E2%80%93-1-06-04-Polity-and-Constitution-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "350",
//     title: "GS PAPER 2 - Volume 2",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "International Relations",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134659/8.-G.S.-Paper-%E2%80%93-2-Volume-%E2%80%93-2-06-04-International-Relations-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "351",
//     title: "GS PAPER 2 - Volume 3",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Society, Social Justice and Governance",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134701/9.-G.S.-Paper-%E2%80%93-2-Volume-%E2%80%93-3-06-04-Society-Social-Justice-and-Governance-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "352",
//     title: "GS PAPER 3 - Volume 1",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Economy",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134704/10.-G.S.-Paper-%E2%80%93-3-Volume-%E2%80%93-1-06-04-Economy-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "353",
//     title: "GS PAPER 3 - Volume 2",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Environment, Ecology and Biodiversity",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134706/11.-G.S.-Paper-%E2%80%93-3-Volume-%E2%80%93-2-06-04-Environment-Ecology-and-Biodiversity-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "354",
//     title: "GS PAPER 3 - Volume 3",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Science and Tech",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134709/12.-G.S.-Paper-%E2%80%93-3-Volume-%E2%80%93-3-06-04-Science-_-Tech-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "355",
//     title: "GS PAPER 3 - Volume 4",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Disaster Management and Internal Security",
//     label: "Disaster Management and Internal Security",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134711/13.-G.S.-Paper-%E2%80%93-3-Volume-%E2%80%93-4-06-04-Disaster-Management-and-Internal-Security-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
//   {
//     id: "356",
//     title: "GS PAPER 4 - Volume 1",
//     image:
//       "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Samples/ezgif-1-cea2e27a41.webp",
//     subtitle: "Ethics, Integrity and Essay Writing",
//     label: "English",
//     file: "https://toppersnotes-main.s3.ap-south-1.amazonaws.com/wp-content/uploads/2022/04/06134713/IAS-Essay-06-04-Written-sample-min.pdf",
//     active: "1",
//     ProductId: "87447",
//   },
// ];

const ProductCover = ({ productSamples, productName }) => {
  {
    /*const handleViewSample = (sampleId, sampleName, sampleURL, index) => {*/
  }
  {
    /*  // window.webengage.track("Product Samples Viewed", {*/
  }
  {
    /*  //   "Product slug": product.product_link,*/
  }
  {
    /*  //   "Product Name": product.name,*/
  }
  {
    /*  //   "FPJS ID":*/
  }
  //   //     localStorage.getItem("FPJS") &&
  //   //     localStorage.getItem("FPJS").replace(/"/g, ""),
  //   //   // "Sample ID": sampleId,
  //   //   "Sample Name": sampleName,
  //   //   "Sample URL": sampleURL,
  //   //   "Sample Index": index,
  //   //   Subdomain: "web.toppersnotes.com",
  //   // });
  // };

  //   console.log(productSamples);

  const [samplesEvent, setSamplesEvent] = useState(false);
  return (
    <div className="container mx-auto">
      {/*<div className="text-l relative">*/}
      {/*    <h2>*/}
      {/*<span className="mt-2 block text-center text-2xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">*/}
      {/*  Samples*/}
      {/*</span>*/}
      {/*    </h2>*/}
      {/*</div>*/}
      <div className="overflow-hidden bg-white mt-12 px-3 md:px-0 mb-10">
        <ul role="list" className="md:flex md:flex-wrap md:gap-x-24">
          {productSamples &&
            productSamples.map((sample) => (
              <li
                key={sample.id}
                className="samples-listing mb-2 border divide-gray-200 rounded-lg shadow"
              >
                <a
                  onClick={() => {
                    if (productName) {
                      if (!samplesEvent) {
                        ReactGA.event({
                          category: "file viewed",
                          action: "samples_file_viewed",
                          label: productName,
                          // nonInteraction: true,
                        });
                        setSamplesEvent(true);
                      }
                    }
                  }}
                  href={sample.file}
                  target="_blank"
                  className="block hover:bg-gray-50"
                >
                  <div className="flex items-center px-4 py-2 sm:px-6">
                    <div className="flex min-w-0 flex-1 items-center">
                      <div className="flex-shrink-0">
                        <img
                          className="w-12 rounded-md sm:w-14 lg:w-16"
                          src={sample.image}
                          alt=""
                        />
                      </div>
                      <div className="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4">
                        <div>
                          <p className="text-sm font-medium text-indigo-600">
                            {sample.title}
                          </p>
                          <p className="mt-2 flex items-center text-sm text-gray-500">
                            <span className="truncate">{sample.subtitle}</span>
                          </p>
                        </div>
                        <div className="hidden md:block"></div>
                      </div>
                    </div>
                    <div>
                      <DocumentDownloadIcon
                        className="h-6 w-6 text-indigo-600"
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                </a>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

React.memo(ProductCover, (preProps, nextProps) => {
  if (JSON.stringify(preProps.product) !== JSON.stringify(nextProps.product))
    return true;
  return false;
});

export default ProductCover;
